import { render, staticRenderFns } from "./flashBanner.vue?vue&type=template&id=a4198c94&"
import script from "./flashBanner.vue?vue&type=script&lang=js&"
export * from "./flashBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports